import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import VueSweetalert2 from "vue-sweetalert2";
import feather from "vue-icon";
// vue icons
import vueSmoothScroll from "vue2-smooth-scroll";
Vue.use(vueSmoothScroll);
Vue.use(feather, "v-icon");
import VueFirestore from "vue-firestore";
// Firebase
import "@/firebase/firebaseConfig";
import "firebase/firestore";
Vue.use(VueFirestore);
// Vuex Store
import store from "./store/store";
// axios
import axios from "./axios.js";
Vue.prototype.$http = axios;
// alert VueSweetalert2
import "sweetalert2/dist/sweetalert2.min.css";
Vue.use(VueSweetalert2);

// bootstrap
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

//
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
